// extracted by mini-css-extract-plugin
export var heroImage = "styles-module__heroImage___buKGw";
export var pageContainer = "styles-module__pageContainer___F9brU";